/**
 * API Endpoints and HTTP paths constants
 * Contains all API routes, service URLs and endpoint definitions
 */

export const COMMENTS_PATH = 'api/v2/comments';
export const POST_ATTACHMENTS_PATH = 'api/v2/attachments';
export const GET_ASSESSMENT_COMMENTS_PATH = 'api/v2/assessment-executions';
export const PUT_SEND_ASSESSMENT_TO_LEADERS_PATH = 'api/v1/valoration/send-valoration-leader';
export const PUT_SEND_RESULT_PRAGMATIC_PATH = 'api/v1/valoration/send-result-pragmatic';
export const GET_STATUS_ACTIVE_VALORATION = 'api/v1/valoration/get-status-active';
export const GET_LAST_VALORATION_PATH = 'api/v1/valoration/get-filter';
export const GET_INSTANCE_VALORATION_PATH = 'api/v1/valoration';
export const GET_VALIDATE_SELF_ASSESSMENT = '/validate-self-assessment';
export const POST_FINALIZED_AUTOVALORATION = 'api/autovaloration/finalizar';
export const POST_ASSESSMENT_COMMENTS_PATH = 'api/v2/assessment-executions/super';
export const PUT_ASSESSMENT_APPROVE_PATH = 'api/v1/valoration/approval-leader';
export const PUT_ASSESSMENT_REJECT_PATH = 'api/v1/valoration/reject-to-leaders';
export const POST_SAVE_METADATA_ASSESSMENT = 'api/v1/valoration/save-metadata';
export const POST_SAVE_PARTIAL_ASSESSMENT = 'api/v1/valoration/save-partial';
export const getAssessmentTraceabilityPath = (assessmentExecutionId: number): string =>
  `api/v1/valoration/${assessmentExecutionId}/traceability`;
export const POST_SENIORITY_ASSESSMENT = 'api/v1/seniority/evaluate';
export const GET_PRAGMAPOWER_CATEGORIES_PATH = 'api/v2/pragmapower-categories';
export const GET_PRAGMAPOWER_DEFINITIONS_PATH = 'api/v2/pragmapower-definitions';
export const GET_SCORES_PATH = 'api/v2/scores';
export const GET_ASSESSMENT_BEHAVIOR_PATH = 'api/v2/assessment-behavior';
export const GET_PRAGMAPOWER_TYPES_PATH = 'api/v2/pragmapower-types';
export const GET_MAP_DEFINITIONS_PATH = 'api/v2/map-definitions';
export const GET_GRADE_CONVERSION_SETTINGS_PATH = 'api/v2/grade-conversion-settings';
export const GET_PENDING_SKILL_TESTS_PATH = 'api/v2/pending-skill-tests';
export const GET_BEHAVIOR_PATH = 'api/v1/behaviors/paginated';
export const POST_BEHAVIOR_PATH = 'api/v1/behaviors';
export const POST_MISSION_PATH = 'api/v1/missions';
export const GET_MISSIONS_LIST_PATH = 'api/v1/missions/list';
export const POST_MAP_EDIT =
  'administration/api/v2/chapter-speciality-technology-maps/maps/update-map-behavior';
export const GET_PRAGMAPOWERS_PATH = 'api/v1/pragmapowers/paginated';
export const POST_PRAGMAPOWER_PATH = 'api/v1/pragmapowers';
export const GET_PRAGMAPOWER_TYPE_PATH = 'api/v1/pragmapower-type/paginated';
export const POST_SKILLSET_PATH = 'api/v1/cart';
export const DELETE_SKILLSET_PATH = 'api/v1/cart/behaviors';
export const GET_COMMENTS_GENERAL_PATH = 'api/v2/comments/behavior/';
export const GET_ATTACHMENTS_PATH = 'api/v2/attachments';
export const GET_MAPS_LIST_PATH =
  'administration/api/v2/chapter-speciality-technology-maps/list/maps';
export const POST_CREATE_MAP_DRAFT =
  'administration/api/v2/chapter-speciality-technology-maps/maps/clone-draft';
export const GET_MAP_ID = 'api/v1/map';
export const GET_NO_GROWTH_REASONS_PATH = 'api/v1/no-growth-reason';
export const GROWTH_MAPS_INFO =
  'administration/api/v2/chapter-speciality-technology-maps/growth-map-info';
export const POST_EXPECTED_SCHEDULE_PUBLISH =
  'administration/api/v2/chapter-speciality-technology-maps/expected-schedule-publish';
export const POST_SCHEDULE_PUBLISH =
  'administration/api/v2/chapter-speciality-technology-maps/schedule-publish';
export const GET_BEHAVIOR_ID = 'api/v1/behaviors';
export const GET_BEHAVIOR_TRACKING_PATH = 'api/v1/valoration/behavior-tracking';
export const PUT_BEHAVIOR_TRACKING_MISSION_PATH = 'api/v1/valoration/behavior-tracking/mission';
export const POST_BEHAVIOR_TRACKING_TOOL_PATH = 'api/v1/valoration/behavior-tracking/tool';
export const GET_TECHNOLOGY_LIST_PATH = 'administration/api/v2/technology/list';
export const GET_TOOLS_LIST_PATH = 'api/v1/tools/list';
export const GET_PROFESSIONAL_PROFILES_PATH = 'administration/api/v2/professional-profiles/list';
export const SAVE_ROLE_INFORMATION_PATH = 'administration/api/v2/chapter-speciality';
export const GET_ROLE_INFORMATION_BY_ID_PATH = 'administration/api/v2/chapter-speciality';
export const GET_CHAPTER_ACCESS_BY_PRAGMATIC_ID_PATH =
  'administration/api/v2/chapter-access/pragmatic';
export const GET_SENIORITIES_LIST = 'seniorities/all';
export const GET_METRICS_PATH = 'administration/api/v2/chapter/metrics/';
export const GET_EXPERIENCE_FRAME = 'api/v2/experience-scale';
export const POST_SAVE_ROL_PATH = 'administration/api/v2/chapter-speciality';
export const GET_MISSIONS_BY_ROLE_PATH = 'api/v1/missions/pragmaPowers';
export const GET_TOOLS_BY_FOCUS_PATH = 'api/v1/tools';
export const GET_BEHAVIORS_PATH = 'administration/api/v2/chapter-speciality/behaviors';
export const GET_PRAGMA_POWERS_BY_TYPE = 'api/v1/pragmapowers';
export const SENIORITY_LIST_PATH = 'administration/api/v2/seniority/list';
export const GET_VALUE_DIFFERENTIAL = 'administration/api/v2/seniority/differential-value';
export const GET_PRAGMA_POWER_BY_ID_PATH = 'api/v1/pragmapowers';
export const GET_PRIVATE_COMMENT = 'private=true';
export const GET_GENERAL_COMMENT = 'general=true&';
export const GET_ADDITIONAL_COMMENTS = 'additional=true';
export const GET_BEHAVIORS_COMMENT = 'comments=true';
export const GET_BEHAVIORS_ATTACHMENTS = 'attachment=true';
export const FILTER_SENIORITY_BEHAVIOR_COMMENTS = 'seniority=';
export const GET_LEARNING_ACTIVITY_BY_ID_PATH = 'api/v1/learning-activities';
export const PRAGMATIC_PERMISSIONS_PATH = 'pragmatic/permissions';
export const GET_BEHAVIORAL_ATTRIBUTES_PATH = 'api/v1/behaviors/attributes';
export const PUT_BEHAVIORAL_ATTRIBUTES_PATH = 'api/v1/behaviors/visibility';
export const POST_BEHAVIOR_SECTION_MAPS_PATH = 'api/v1/behavior-section-maps';
export const GET_BEHAVIORAL_LINES_PATH = 'api/v1/behavioral-lines';
export const POST_BEHAVIORAL_LINE_PATH = 'api/v1/behavioral-lines';
export const GET_SENIORITY_THRESHOLDS = 'api/v1/seniority-config';
export const PUT_SENIORITY_THRESHOLDS = 'api/v1/map';
export const IS_HORIZONTAL = 'is-horizontal';
export const SECTION_THRESHOLDS = 'section-thresholds';
export const SECTION_LEVELS = 'section-levels';

export enum AchievementRequest {
  AchievementState = '/achievementState/achievementStateId',
  ReportingMail = '/reportingMail',
  Novelty = '/novelty',
}

export enum SchedulingEndpoints {
  AvailableSchedule = 'available',
  ScheduleEvents = 'events',
  SchedulingRestriction = 'schedulingRestriction',
  ConfigSteps = 'parameters/configSteps',
  AvailableDates = 'available/dates',
}

export enum GrowthRouteEndpoints {
  Objectives = 'goals',
  reorderObjectives = 'goals-assigned/update-order-and-priority',
  Categories = 'categories',
  Priorities = 'priorities',
  Purposes = 'purposes/by-origin/',
  activities = '',
  AddActivity = 'goals/{goalAssignedId}/activity',
  UpdateActivity = 'goals/{goalAssignedId}/activity/{activityId}',
  UpdateActivityVisibility = 'goals/{goalAssignedId}/activity/{activityId}/visible',
  UpdateGoalPurpose = 'goals/{goalAssignedId}/purpose',
  UpdateGoalAssigned = 'goals/{goalAssignedId}',
  UpdateGoalDefinition = 'goals/{goalId}/definition',
  GoalsFromCart = 'goals/from-cart',
  MarkGoalSeen = 'goals/{goalAssignedId}/mark-seen',
  TriggerPrioritization = 'prioritization/trigger',
}

export enum CauseOfNonGrowthEndpoints {
  CausesOfNonGrowthOptions = 'api/v2/no-growth-reasons',
  RegisterCauseOfNonGrowth = 'api/v2/register-no-growth',
}

export enum AchievementsPayload {
  PragmaticNotNotifiedPath = '/pragmaticIsNotified',
}

export enum PragmaticServiceRoutes {
  PragmaticChapterDetail = 'administration/api/v2/pragmatic-chapters/updatePragmatic',
  Valoration = 'valoration',
  ChapterList = 'chapterList',
  SeniorityFilter = 'seniorityFilter',
  AssessmentUrl = 'assessmentUrl',
  AdministrationPragmaticList = 'administration/api/v2/pragmatic/list',
  AdministrationChapterSpecialityTechnology = 'administration/api/v2/chapter-speciality-technology/chapterId',
  TrackingToolProcessData = 'trackingTool/processData',
  TrackingToolResendAssessmentEmail = 'trackingTool/resendAssessmentEmail',
  ChapterUsers = 'administration/api/v2/chapter/users',
  Chapters = 'chapters',
  AdministrationChaptersList = 'administration/api/v2/chapter/chapters',
}

export enum AssessmentDateServiceRoutes {
  UpdateAssessmentDate = 'assessment/update-assessment-date',
}

export enum HEADERS_INTERCEPTOR_ALLOWED_URLS {
  AssessmentsPA = 'assessments-pa',
  Administration = 'administration',
  LocalIntegration = 'localhost:9030',
}

export const getPragmaPowerBehaviorDefinitionsByCompetenceId = (competenceId: number) => {
  return `${GET_PRAGMAPOWER_DEFINITIONS_PATH}/${competenceId}/behavior-definitions` as const;
};

export const getScoresBehaviorByBehaviorId = (behaviorId: number) => {
  return `${GET_SCORES_PATH}/behavior/${behaviorId}` as const;
};

export const getPragmaticChapterDetailsByEmail = (email: string) => {
  return `${PragmaticServiceRoutes.PragmaticChapterDetail}/${email}` as const;
};

export const getPragmaticValorationDataByEmail = (email: string) => {
  return `${PragmaticServiceRoutes.Valoration}/${email}` as const;
};

export const getPragmaticValorationDataByToken = () => {
  return `${PragmaticServiceRoutes.Valoration}` as const;
};

export const getPragmaticValorationDataById = (pragmaticId: number) => {
  return `${PragmaticServiceRoutes.Valoration}/byId/${pragmaticId}` as const;
};

export const getPragmaticChapterDetailsByEmailAndChapterId = (email: string, chapterId: string) => {
  return `${PragmaticServiceRoutes.PragmaticChapterDetail}/${email}/${chapterId}` as const;
};

export const getPragmaticProfileByEmail = (email: string) => {
  return `pragmatic/${email}` as const;
};

export const getPragmaticProfileByToken = () => {
  return `pragmatic` as const;
};

export const getPragmaticProfileById = (pragmaticId: number) => {
  return `pragmatic/byId/${pragmaticId}`;
};

export const getAssessmentPragmaPowersByAssessmentId = (idAssessment: number) => {
  return `${GET_ASSESSMENT_COMMENTS_PATH}/${idAssessment}/assessment-pragmapowers` as const;
};

export const getAssessmentBehaviorById = (id: number) => {
  return `${GET_ASSESSMENT_BEHAVIOR_PATH}/${id}` as const;
};

export const getAssessmentExecutionStatusByIdAssessment = (idAssessment: number) => {
  return `${GET_ASSESSMENT_COMMENTS_PATH}/${idAssessment}/status` as const;
};

export const getAdministrativeLeaderStatusByIdLeader = (idLeader: number) => {
  return `api/v2/administrative-leaders/${idLeader}/status` as const;
};

export const getValorationStatusActive = (): string => {
  return `${GET_STATUS_ACTIVE_VALORATION}` as const;
};

export const getAssessmentExecutionStatusNotificationByIdAssessment = (idAssessment: number) => {
  return `${GET_ASSESSMENT_COMMENTS_PATH}/${idAssessment}/status/notification` as const;
};

export const getAssessmentExecutionsByAssessmentExecutionId = (assessmentExecutionId: number) => {
  return `${GET_ASSESSMENT_COMMENTS_PATH}/${assessmentExecutionId}` as const;
};

export const getCommentsById = (id: number) => {
  return `${COMMENTS_PATH}/${id}` as const;
};

export const getAssessmentExecutionsSelfAssessedByAssessmentId = (assessmentId: number) => {
  return `${GET_ASSESSMENT_COMMENTS_PATH}/self-assessed/${assessmentId}` as const;
};

export const getAssessmentExecutionsSuperByAssessmentId = (assessmentId: number) => {
  return `${POST_ASSESSMENT_COMMENTS_PATH}/${assessmentId}` as const;
};

export const getGraphAssessmentById = (id: string) => {
  return `graphAssessment/${id}` as const;
};

export const getFilterByTechnologyAndSpecialityByChapterId = (chapterId: string) => {
  return `administration/filterByTechnologyAndSpeciality/${chapterId}` as const;
};

export const getPragmaticChapterDetailsSyncByEmail = (email: string) => {
  return `${PragmaticServiceRoutes.PragmaticChapterDetail}/sync/${email}` as const;
};

export const modifyAssesmentDate = () => {
  return `${AssessmentDateServiceRoutes.UpdateAssessmentDate}` as const;
};
